/**
 * @file コンポーネント：フル動画ページ決済情報ポップアップ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPopupContainer = styled.div``;

export const StyledPopupContainerBody = styled.form`
    display: flex;
    flex-direction: column;
`;

export const StyledPopupContainerBodyDescription = styled.div`
    order: 4;
    height: 100px;
    padding: 16px;
    overflow: auto;
    background-color: #d9d9d9;
    color: #000000;
    font-size: 12px;
    line-height: 14px;
`;

export const StyledPopupContainerBodyDescriptionAnchor = styled.a`
    color: #000000;
`;

export const StyledPopupContainerBodyDescriptionAnchorIcon = styled.span`
    margin-left: 4px;
`;

export const StyledPopupContainerBodyDescriptionAnchorText = styled.span``;

export const StyledPopupContainerBodyPrice = styled.div`
    order: 3;
    margin-bottom: 16px;
    text-align: right;
`;

export const StyledPopupContainerBodyThumbnail = styled.div`
    order: 1;
    position: relative;
    margin-bottom: 16px;
    overflow: hidden;

    &::before {
        display: block;
        padding-top: 56.25%;
        content: "";
    }
`;

export const StyledPopupContainerBodyThumbnailImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
`;

export const StyledPopupContainerBodyTitle = styled.h3`
    order: 2;
    margin-bottom: 16px;
    overflow: hidden;
    color: #000000;
    font-size: 14px;
    line-height: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
